import { Declarant } from "../../models/Declarant";
import { IHasChildren } from "../common/Table/Interfaces";
import React from "react";
interface Props {
  entity: IHasChildren<Declarant>;
  index: number;
}

export const IndexColumn: React.FC<Props> = ({ entity, index }) => {
  const childElement = entity.children ? null : index + 1;

  return <p className="index-column">{childElement}</p>;
};
